import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Link from 'valuelink';
import { Popconfirm, message, Button, DatePicker } from 'antd';
import { Input } from 'valuelink/lib/tags';
import moment from 'moment';
import { RegularText, SemiboldText } from '../../components/common/Text';
import { setDoctorProfile } from '../../actions/index';
import {
  fetchDoctorMemberships,
  deleteMembership,
  updateMembership,
} from '../../services';

const { RangePicker } = DatePicker;

const OuterContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
`;

const TitleText = styled(SemiboldText)`
  font-size: 1.5rem;
  text-align: center;
  color: #666569;
`;

const ColContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 20px;
  /* over */
`;

const StyledInputBox = styled(Input)`
  font-size: 16px !important;
  background-color: #f8f8f8;
  align-self: stretch;
  border-radius: 6px;
  flex: 1;
  flex-shrink: 0;
  min-width: 180px;
  /* max-width: 380px; */
  height: 44px;
  padding: 6px 12px;
  align-items: center;
`;

const LabelText = styled(SemiboldText)`
  font-size: 12px;
  text-align: center;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  color: #7c7c7c;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
`;

const MembershipRow = styled.div`
  display: flex;
  flex-direction: row;
  margin: 16px;
  padding: 8px;
  box-shadow: 0 3px 5px 2px rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
  align-items: center;
  justify-content: space-between;
`;

const MembershipNumber = styled(SemiboldText)`
  font-size: 16;
  color: #666569;
`;

const MembershipInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const MembershipText = styled(RegularText)`
  font-size: 14;
  color: #666569;
  margin: 0px 10px 0px 10px;
`;

const EduRowComponent = styled.div`
  display: flex;
  flex-direction: row;
`;

class DoctorMembershipScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      memberships: [],
      doctorMembershipId: null,
      title: '',
      institution: '',
      fromDate: '',
      toDate: '',
      formEditing: false,
    };
    console.log({ props });

    this.doctorId = props.doctorId;
  }

  componentDidMount = () => {
    this.fetchMembership();
  };

  componentDidUpdate = () => {
    if (document.getElementById('edit-form')) {
      document.getElementById('edit-form').scrollIntoView();
    }
  };

  fetchMembership = () => {
    const { dispatch } = this.props;
    fetchDoctorMemberships(this.doctorId).then(res => {
      const memberships = res.data;
      dispatch(setDoctorProfile({ memberships }));
      this.setState({
        memberships,
      });
    });
  };

  submit = () => {
    const {
      doctorMembershipId,
      title,
      institution,
      fromDate,
      toDate,
    } = this.state;

    updateMembership({
      doctorId: this.doctorId,
      doctorMembershipId,
      title,
      institution,
      fromDate,
      toDate,
    })
      .then(() => {
        this.cancelEditing();
        this.fetchMembership();
      })
      .catch(err => {
        console.log({ err });
      });
  };

  deleteMembership = doctorMembershipId => {
    deleteMembership(this.doctorId, doctorMembershipId)
      .then(() => {
        message.success('Membership deleted successfully');
        this.fetchMembership();
      })
      .catch(err => {
        console.log({ err });
      });
  };

  editMembership = edu => {
    this.setState({
      formEditing: true,
      doctorMembershipId: edu.doctorMembershipId,
      title: edu.title || '',
      institution: edu.institution || '',
      fromDate: edu.fromDate || '',
      toDate: edu.toDate || '',
    });
  };

  cancelEditing = () => {
    this.setState({
      formEditing: false,
      doctorMembershipId: null,
      title: '',
      institution: '',
      fromDate: '',
      toDate: '',
    });
  };

  onFromToDateChange = (date, dateString) => {
    console.log({ date, dateString });
    this.setState({
      fromDate: dateString[0],
      toDate: dateString[1],
    });
  };

  onCurrentChange = e => {
    console.log(`checked = ${e.target.checked}`);
    this.setState({
      current: e.target.checked,
    });
  };

  render() {
    const { memberships } = this.state;
    const titleLink = Link.state(this, 'title');
    const institutionLink = Link.state(this, 'institution');

    const membershipsForm = () => {
      console.log({ state: this.state });
      return (
        <MembershipRow id="edit-form">
          <BodyContainer>
            <LabelText>Membership Title</LabelText>
            <StyledInputBox
              className="visit-input"
              valueLink={titleLink}
              placeholder="Title"
            />

            <LabelText>Institution</LabelText>
            <StyledInputBox
              className="visit-input"
              valueLink={institutionLink}
              placeholder="Institution"
            />

            <LabelText>From Date - To Date</LabelText>
            <RangePicker
              onChange={this.onFromToDateChange}
              style={{ marginBottom: 20 }}
              defaultValue={
                this.state.fromDate
                  ? [
                      moment(this.state.fromDate, 'YYYY-MM-DD'),
                      moment(this.state.toDate, 'YYYY-MM-DD'),
                    ]
                  : null
              }
            />

            <EduRowComponent>
              <Button
                type="primary"
                style={{ marginRight: 10 }}
                onClick={this.submit}
              >
                Submit
              </Button>
              <Button onClick={this.cancelEditing}>Cancel</Button>
            </EduRowComponent>
          </BodyContainer>
        </MembershipRow>
      );
    };

    const renderMembership = (edu, idx) => (
      <MembershipRow>
        <EduRowComponent>
          <MembershipNumber>{idx + 1}. </MembershipNumber>
          <MembershipInfo>
            <MembershipText>{edu.title}</MembershipText>
            <MembershipText>
              {`${edu.institution}, From: ${edu.fromDate} To:${edu.toDate}`}
            </MembershipText>
          </MembershipInfo>
        </EduRowComponent>
        <EduRowComponent>
          <Button
            type="primary"
            style={{ marginRight: 10 }}
            onClick={() => this.editMembership(edu)}
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure delete this?"
            onConfirm={() => this.deleteMembership(edu.doctorMembershipId)}
            // onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            <Button type="danger">Delete</Button>
          </Popconfirm>
        </EduRowComponent>
      </MembershipRow>
    );

    return (
      <OuterContainer>
        <TitleText>Doctor Membership Screen</TitleText>
        <ColContainer>{memberships.map(renderMembership)}</ColContainer>
        {!this.state.formEditing && (
          <Button
            style={{ alignSelf: 'center', flex: 0, padding: 4 }}
            onClick={() => this.editMembership({})}
          >
            Add Membership
          </Button>
        )}
        {this.state.formEditing && membershipsForm()}
      </OuterContainer>
    );
  }
}

const mapStateToProps = state => ({
  authToken: state.user.authToken,
});

export default connect(mapStateToProps)(DoctorMembershipScreen);
